import React from "react";
import Doughnut from "../GraphViews/Doughnut";
import StatsUtils from "../../../../utils/stats";
import CountUp from "react-countup";
import Spinner from "../Spinner";
import { FormattedMessage } from "react-intl";

const GlobalKpiViewNumber = props => {
  let _data = props.data || {};
  let data = _data.data || [];
  const valuesArray = data.map(data => data && data.v);
  const oldestValue = valuesArray.length > 0 ? valuesArray[0] : 0;
  const newestValue = valuesArray.length > 0 ? valuesArray[valuesArray.length - 1] : 0;
  const indicator = _data.indicator || 0;
  const kpi = props.kpi || {};
  const trend = Math.sign(newestValue - oldestValue);
  const color = trend === 1 ? "#54CD98" : trend === -1 ? "#DB1E08" : "#FEA701"; //"#FFBF00"
  const iconClass = trend === 0 ? "icon-equal" : trend === -1 ? "icon-arrow-down" : "icon-arrow-up";

  return (
    <div className="p-al-r-center p-w-h-100">
      <div className="p-al-r-full-center p-w-1-3" style={{ backgroundColor: color, width: "34%" }}>
        <div
          className={`icon-${StatsUtils.kpiToIconClassName(props.kpi)}`}
          style={{ fontSize: "6vh", color: "#fff" }}
        />
      </div>
      <div className="p-al-r-full-center p-w-2-3 p-pdg-full">
        <div>
          <h2 className="p-page-subtitle p-txt-center">
            {props.title ? (
              <FormattedMessage id={props.title} defaultMessage={props.title}>
                {txt => <React.Fragment>{txt}</React.Fragment>}
              </FormattedMessage>
            ) : null}
          </h2>
          <div
            className="p-txt-center"
            style={{
              fontWeight: "bold",
              marginTop: "5%",
              fontSize: "4vh"
            }}
          >
            <CountUp
              start={0}
              end={StatsUtils.roundKpiValue(kpi, indicator)}
              duration={3}
              separator=" "
              style={{ fontSize: "4vh" }}
              decimals={indicator % 1 === 0 ? 0 : 2}
              formattingFn={v => {
                return StatsUtils.formatKpiValue(kpi, v);
              }}
            />
            <div className={iconClass} style={{ fontSize: "4vh", marginTop: "20%" }} />
          </div>
        </div>
      </div>
    </div>
  );
};

const GlobalKpiView = props => {
  let data = props.data || {};
  let indicator = data.indicator || 0;
  data = data.data || [];
  const valuesArray = data.map((d = {}) => {
    if (d) {
      return d.v || 0;
    }

    return 0;
  });
  const oldestValue = valuesArray.length > 0 ? valuesArray[0] : 0;
  const newestValue = indicator;
  //valuesArray.length > 0 ? valuesArray[valuesArray.length - 1] : 0;
  const kpi = props.kpi || {};
  const trend = Math.sign(newestValue - oldestValue);
  const color = trend === 1 ? "#54CD98" : trend === -1 ? "#DB1E08" : "#FEA701"; //"#FFBF00"
  const iconClass = trend === 0 ? "icon-equal" : trend === -1 ? "icon-arrow-down" : "icon-arrow-up";

  if ((!kpi.format || kpi.format === "Pourcentage" || kpi.format_input === "percentage") && props.title) {
    return (
      <React.Fragment>
        <h2 className="p-page-subtitle p-txt-center">
          <FormattedMessage id={props.title} defaultMessage={props.title}>
            {txt => <React.Fragment>{txt}</React.Fragment>}
          </FormattedMessage>
        </h2>
        <div
          className="p-mrg-top-s p-al-r-full-center p-flex-1"
          style={{
            height: "calc(100% - 20px)",
            //overflow: "hidden",
            position: "relative"
          }}
        >
          {props.loading ? (
            <Spinner />
          ) : (
            <Doughnut
              newestPercentage={newestValue}
              oldestPercentage={oldestValue}
              kpi={kpi}
              circleTitle={props.circleTitle}
            />
          )}
        </div>
      </React.Fragment>
    );
  }

  return (
    <React.Fragment>
      <div className="p-al-c-center p-flex-1" style={{ height: "100%", overflow: "hidden", position: "relative" }}>
        {props.loading ? <Spinner /> : <GlobalKpiViewNumber {...props} />}
      </div>
    </React.Fragment>
  );
};

export default GlobalKpiView;

/*


*/



// WEBPACK FOOTER //
// src/modules/stats/components/DashboardViews/GlobalKpiView.js